<div class="overlay-wrapper">
  <ng-content></ng-content>
  <div class="overlay">
    <div class="overlay-content">
      Coming soon
    </div>
  </div>
</div>
